import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-entrega-factura',
  templateUrl: './entrega-factura.component.html',
  styleUrls: ['./entrega-factura.component.scss']
})
export class EntregaFacturaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
